/**
 * Button variant and size type definitions and mappings
 */

// Button variant types
export type ButtonVariant = 'primary' | 'secondary' | 'accent';

// Button size types
export type ButtonSize = 'small' | 'medium' | 'large';

// Button type definitions for shape/style
export type ButtonType = 'square' | 'round' | 'pill';

// Mapping from button variants to their corresponding button keys in the style config
export const BUTTON_VARIANT_TO_KEY: Record<ButtonVariant, string> = {
  primary: 'button1',
  secondary: 'button2',
  accent: 'button3',
} as const;

// Reverse mapping from button keys to variants (useful for validation)
export const BUTTON_KEY_TO_VARIANT: Record<string, ButtonVariant> = {
  button1: 'primary',
  button2: 'secondary',
  button3: 'accent',
} as const;

// Array of all valid button variants (useful for validation and iteration)
export const BUTTON_VARIANTS: readonly ButtonVariant[] = [
  'primary',
  'secondary',
  'accent',
] as const;

// Array of all valid button sizes (useful for validation and iteration)
export const BUTTON_SIZES: readonly ButtonSize[] = ['small', 'medium', 'large'] as const;

// Array of all valid button types (useful for validation and iteration)
export const BUTTON_TYPES: readonly ButtonType[] = ['square', 'round', 'pill'] as const;
